import React, {useEffect, useState} from "react";
import "../../assets/styles/components/payback.scss";
import arrowLeftPayback from "../../assets/svg/arrowLeftPayback.svg";
import backgroundNewAuth from "../../assets/svg/background-new-auth.svg";
import gifPayment from "../../assets/animation_500_l49xm69o.gif";
import paymentFailed from "../../assets/images/paymentFailed.gif";
import logo from "../../assets/images/logo_blue.png";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {apiSubscriptionPayback} from "../../api/subsciptionApi";
import {setBusiness} from "../../store/actions/businessAction";
import {appSetFiscalYear, appSetFiscalYears} from "../../store/actions/appAction";
import axios from "../../axios/axios";
import { useAppSelector } from "store/store";


export default function Payback() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const store = useAppSelector((state) => state);
    const user = store.userReducer.user;
    const token = user?.token;
    const dashboard = store.dashboardReducer.dashboard;
    const business = store.businessReducer.business?.business;
    const authority = query.get("Authority");
    const status = query.get("Status");
    const success = query.get("success");
    const [successFull, setsuccessFull] = useState(success)
    const paymentData = useSelector((state) => state).appReducer.paymentData;

    useEffect(() => {
        if (paymentData && paymentData.businessId && success === undefined) {
            dispatch(apiSubscriptionPayback(authority, paymentData.businessId, token));
        }
    }, []);
    useEffect(() => {
        if (success === "1") {
            const UUID = localStorage.getItem('yektaPayuuid')
            if (UUID !== null) {
                axios
                    .post("/subscriptions/verify", {
                        // subscriptionId: active.subscription?.subId,
                        transactionId: UUID,
                        businessId: business.id,
                        paymentGateWay: "yektaPay",
                        // offlineCount: active.subscription?.offlineCount,
                        // branchCount: active.subscription?.branchCount,
                        // price: active.subscription?.price,
                    }, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then((response) => {
                        if(response.data.isSuccessful){
                            setTimeout(()=>{
                                navigate('/auth/logout')
                            },3000)
                        }
                        
                        setsuccessFull(response.data.isSuccessful)
                    })
                    .catch((error) => {
                    });

            }
        }

        return () => {

        }
    }, [success])

    return (
        <div className="wrap-payback-c">
            <img src={backgroundNewAuth} alt="backgroundNewAuth" className="background-new-auth" />
            <div className="body-payback">
                <div className="wrap-img-logo-payback text-center">
                    <img className="img-style-logo-payment" src={logo} alt="logo" />
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center flex justify-center">
                    <img
                        src={status === "OK" || successFull ? gifPayment : paymentFailed}
                        alt="gifPayment"
                        className="img-style-gif-payment"
                    />
                </div>
                <div className="success-error-payack">{paymentData?.message ?? ""}</div>
                {authority ? (
                    <div className="text-tow-payback">شناسه تراکنش: {parseInt(authority.substr(1))}</div>
                ) : null}
                <div className="btn-back-chortke flex justify-center">
                    <button
                        className="flex items-center flex-row-reverse justify-center gap-4"
                        type="button"
                        onClick={() => {
                            dispatch(setBusiness(null));
                            dispatch(appSetFiscalYears([]));
                            dispatch(appSetFiscalYear(null));
                            navigate("./");
                        }}
                    >
                        بازگشت به داشبورد
                        <img src={arrowLeftPayback} alt="arrowLeftPayback" />
                    </button>
                </div>
            </div>
        </div>
    );
}
